<template>
  <div class="sm:mx-3 sm:rounded-lg shadow-sm bg-surface">
    <slot></slot>
  </div>
</template>

<script setup>
</script>

<style scoped>
</style>
